import React from 'react'
import Header from '../../components/Header/Header'
import Footer from '../../components/Footer/Footer'
import AboutMain from '../../components/main/AboutMain'

function About() {
  return (
    <div>
      <div>
        <Header />
        <AboutMain />
        <Footer />
      </div>
    </div>
  )
}

export default About